import { IShopReviewsData, IShopReviewsAction } from 'models/shop/shopreviews';
import { IComment, IPage } from 'models/common';
import { IStore } from 'IStore';
import { reset } from 'redux-form';
import * as c from 'models/constants';
import * as i18n from 'i18next';
import { actions as notifActions } from 'redux-notifications';
const { notifSend } = notifActions;

/** Action Types */
export const REQUEST_START: string = 'shopreviews/REQUEST_START';
export const REQUEST_FAILURE: string = 'shopreviews/REQUEST_FAILURE';
export const REQUEST_FAILURE_REVIEW: string = 'shopreviews/REQUEST_FAILURE_REVIEW';
export const GET_SUCCESS: string = 'shopreviews/GET_SUCCESS';
export const SET_ITEMS_PAGE: string = 'shopreviews/SET_ITEMS_PAGE';
export const RESET_DATA: string = 'shopreviews/RESET_DATA';
export const SET_ISFIRSTLOAD: string = 'shopreviews/SET_ISFIRSTLOAD';

/** Initial State */
const initialState: IShopReviewsData = {
	items: [],
	isFetching: false,
	itemsPage: {
		currentPage: 0,
		totalPages: 0,
		totalItems: 0,
		itemsPerPage: 10,
		items: [],
	},
	isFirstLoad: false,
	reviewBoxError: {
		status: 0,
		statusText: '',
		error: [],
	},
};

/** Reducer */
export function shopReviewsReducer(state = initialState, action: IShopReviewsAction) {
	switch (action.type) {
		case REQUEST_START:
			return Object.assign({}, state, {
				isFetching: true,
				error: false,
			});

		case GET_SUCCESS:
			return Object.assign({}, state, {
				items: action.payload.items,
				isFetching: false,
			});

		case REQUEST_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				message: action.payload.message,
				error: true,
			});

		case REQUEST_FAILURE_REVIEW:
			return Object.assign({}, state, {
				reviewBoxError: action.payload.message,
			});

		case SET_ITEMS_PAGE:
			return Object.assign({}, state, {
				itemsPage: action.payload.itemsPage,
			});

		case RESET_DATA:
			return Object.assign({}, state, {
				items: [],
				itemsPage: {
					currentPage: 0,
					totalPages: 0,
					totalItems: 0,
					itemsPerPage: 10,
					items: [],
				},
				reviewBoxError: {
					status: 0,
					statusText: '',
					error: [],
				},
			});

		case SET_ISFIRSTLOAD:
			return Object.assign({}, state, {
				isFirstLoad: action.payload.isFirstLoad,
			});

		default:
			return state;
	}
}

/** Action Creator */
export function getReviewsForAllShops(isFirstLoad: boolean, reviewed?: boolean) {
	return (dispatch, getState: () => IStore) => {
		if (isFirstLoad) {
			dispatch(resetData());
			dispatch(setIsFirstLoad(false));
		}

		dispatch(requestStart());

		const currentPage: number = getState().shopReviews.itemsPage.currentPage;
		const newPage: number = currentPage + 1;
		const itemsPerPage: number = getState().shopReviews.itemsPage.itemsPerPage;

		let queryString = '?';
		queryString = queryString + '&currentPage=' + newPage;
		queryString = queryString + '&itemsPerPage=' + itemsPerPage;
		queryString = queryString + '&reviewed=' + reviewed;

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Shop/Comments' + queryString,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'GET',
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res) => {
						if (isFirstLoad) {
							dispatch(resetData());
						}
						const shopReviewsState: IShopReviewsData = getState().shopReviews;
						const items: IComment[] = shopReviewsState.items;
						const newItems: IComment[] = res.items;
						Array.prototype.push.apply(items, newItems);
						dispatch(getSuccess(items));
						dispatch(setItemsPage(res));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Async Action Creator */
export function getShopReviews(id: string, isFirstLoad: boolean) {
	return (dispatch, getState: () => IStore) => {
		if (isFirstLoad) {
			dispatch(resetData());
			dispatch(setIsFirstLoad(false));
		}

		dispatch(requestStart());

		const currentPage: number = getState().shopReviews.itemsPage.currentPage;
		const newPage: number = currentPage + 1;
		const itemsPerPage: number = getState().shopReviews.itemsPage.itemsPerPage;

		let queryString = '?';
		queryString = queryString + '&currentPage=' + newPage;
		queryString = queryString + '&itemsPerPage=' + itemsPerPage;

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Shop/' + id + '/Comments' + queryString,
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res) => {
						const items = getState().shopReviews.items;
						const newItems: IComment[] = res.items;
						Array.prototype.push.apply(items, newItems);
						dispatch(getSuccess(items));
						dispatch(setItemsPage(res));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function addShopReview(comment: IComment) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());
		return fetch(
			getState().fetchDefault.baseAPI + `api/Shop/Comment`,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
				body: JSON.stringify(comment),
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then(() => {
						dispatch(
							notifSend({
								message: i18n.t('Notification_Success_ShopReview_Added'),
								kind: 'success',
								dismissAfter: 6000,
							}),
						);
						dispatch(reset(c.FORM_NAME_ADD_COMMENT));
						dispatch(getShopReviews(comment.parentId, true));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailureReview(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailureReview(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailureReview(err));
			});
	};
}

/** Action Creator - create */
export function approveShopReview(id: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Shop/Comment/' + id + '/Review',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'PUT',
			}),
		)
			.then((res) => {
				if (res.ok) {
					dispatch(
						notifSend({
							message: i18n.t('Notification_Success_ShopReview_Approved'),
							kind: 'success',
							dismissAfter: 3000,
						}),
					);
					dispatch(getReviewsForAllShops(true, false));
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailureReview(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailureReview(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailureReview(err));
			});
	};
}

/** Action Creator - create */
export function deleteShopReview(id: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Shop/Comment/' + id,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'DELETE',
			}),
		)
			.then((res) => {
				if (res.ok) {
					dispatch(getReviewsForAllShops(true, false));
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function requestStart(): IShopReviewsAction {
	return {
		type: REQUEST_START,
	};
}

/** Action Creator */
export function getSuccess(items: IComment[]): IShopReviewsAction {
	return {
		type: GET_SUCCESS,
		payload: {
			items,
		},
	};
}

/** Action Creator */
export function requestFailure(message: any): IShopReviewsAction {
	return {
		type: REQUEST_FAILURE,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function requestFailureReview(message: any): IShopReviewsAction {
	return {
		type: REQUEST_FAILURE_REVIEW,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function setItemsPage(itemsPage: IPage): IShopReviewsAction {
	return {
		type: SET_ITEMS_PAGE,
		payload: {
			itemsPage,
		},
	};
}

/** Action Creator */
export function resetData(): IShopReviewsAction {
	return {
		type: RESET_DATA,
	};
}

export function setIsFirstLoad(isFirstLoad: boolean): IShopReviewsAction {
	return {
		type: SET_ISFIRSTLOAD,
		payload: {
			isFirstLoad,
		},
	};
}
